import { render } from "./ActiveGroups.vue?vue&type=template&id=4e6a09bc"
import script from "./ActiveGroups.vue?vue&type=script&lang=js"
export * from "./ActiveGroups.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__